export const getRoussanneFranceData = () => ({
  name: "Roussanne",
  country: "France",
  description: "Roussanne est un cépage blanc noble originaire du Rhône, principalement cultivé dans les appellations septentrionales et méridionales du Rhône où il produit des vins blancs complexes et aromatiques.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "50 ha", percentage: "0.5%", description: "Cépage blanc d'assemblage, apportant complexité et notes florales" },
    { name: "Hermitage", area: "30 ha", percentage: "15%", description: "Cépage blanc principal avec Marsanne" },
    { name: "Côtes du Rhône", area: "200 ha", percentage: "2%", description: "Cépage blanc important dans les assemblages" },
    { name: "Languedoc-Roussillon", area: "100 ha", percentage: "0.5%", description: "Cultivé dans quelques appellations" },
    { name: "Autres", area: "50 ha", percentage: "0.3%", description: "Dispersé dans le sud de la France" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 1 },
    { region: "Hermitage", x: 51, y: 66, color: "#6d2c7a", size: 2 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#8a4a8a", size: 2 },
    { region: "Languedoc", x: 48, y: 62, color: "#a768a6", size: 1 }
  ],
  characteristics: {
    viticulture: "Cépage délicat, sensible aux maladies, nécessite des soins attentifs",
    climate: "Préfère les climats tempérés à chauds du Rhône",
    soil: "Sols granitiques et calcaires, bien drainés"
  },
  wineStyles: {
    white: "Vins blancs complexes avec des notes florales, de miel et d'épices douces"
  },
  foodPairing: "Poissons gras, fruits de mer, volailles, fromages affinés, cuisine raffinée",
  history: "Roussanne est un cépage blanc très ancien du Rhône, mentionné dans les textes historiques. Son nom évoque la couleur rousse de ses raisins à maturité. Il est traditionnellement assemblé avec Marsanne dans les appellations septentrionales du Rhône et apporte complexité et finesse aux assemblages."
}); 